import React from 'react';
import ErrorMessageContainer from '../containers/ErrorMessage';
import './MainLayout.scss';

const MainLayout = ({ children }) => {
  return (
    <div className="MainLayout">
      <ErrorMessageContainer />
      {children}
    </div>
  );
};

export default MainLayout;
